module.exports = __webpack_public_path__ + "static/media/settings.4d7dbcf6.svg";